import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { useFunnelStore } from "@/stores/funnelStore";

export function RootRedirect() {
  const token = useAuthStore.getState().token;
  const diagnosisId = useFunnelStore.getState().diagnosisId;

  if (token) return <Navigate to="/app" replace />;
  if (diagnosisId) return <Navigate to={`/report/${diagnosisId}`} replace />;
  return <Navigate to="/login" replace />;
}
